/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WochenplanDto } from '../../models/wochenplan-dto';

export interface GetWochenplanById$Plain$Params {
  id: string;
}

export function getWochenplanById$Plain(http: HttpClient, rootUrl: string, params: GetWochenplanById$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<WochenplanDto>> {
  const rb = new RequestBuilder(rootUrl, getWochenplanById$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WochenplanDto>;
    })
  );
}

getWochenplanById$Plain.PATH = '/v1/wochenplaene/{id}';
